export default "__VITE_ASSET__DpJyNPue__"